import { Navigate,Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

const PrivateRoutes = ()=>{
    const auth = useSelector((state)=>state.auth.value);
    return(
        auth.isLoggedIn?<Outlet/>:<Navigate to="/users/login"/>
    )
}
export default PrivateRoutes